import React, { useState, useEffect, useRef } from "react";
import classNames from "classnames";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { getOverallSettingsClasses } from "../../utils/siteUtils";
import { Icon } from "../../elements";
import PrimaryButton from "../../elements/primary-button";
import { mobileIs } from "../../utils/siteUtils";
import "./style.scss";
import { gtag } from "../../utils";
import Swiper from 'swiper';
let i=0;
const FreeRolling = ({ page, lang, rendering, fields }) => {
  const { list, dragtext } = fields;
  const isMobile = mobileIs()
  const isAR = page?.fields?.rtl?.value;
  const [currentIndex, setCurrentIndex] = useState(null)
  const swiper = useRef(null)
  const swiperEl = useRef(null)
  const [showDrag, setShowDrag] = useState(true)
  const [overButton, setOverButton] = useState(false)
  const wrapperEl = useRef(null);
  const [count, setCount] = useState(0);
  const [moving, setMoving] = useState(false);
  const [isMoving, setIsMoving] = useState(false);
  const [swiperRight, setSwiperRight] = useState(0);
  const [mouseDownTime, setMouseDownTime] = useState(null);
  const [isClick, setIsClick] = useState(false);
  const freetimer= useRef();
  const rootEl = useRef()
  const dragEl = useRef()

  const buildSwiper = () => {
    swiper.current = new Swiper(swiperEl.current, {
      loop: true,
      watchSlidesProgress: true,
      slidesPerView: 'auto',
      spaceBetween: isMobile ? 20 : 60,
      centeredSlides: true,
      observer: true,
      navigation: {
        nextEl: isAR ? ".swiper-button-next" : ".swiper-button-prev",
        prevEl: isAR ? ".swiper-button-prev" : ".swiper-button-next",
      },
      on:{
        click(_swiper, event) {
          let realIndex = event.target.parentNode.getAttribute('data-swiper-slide-index') || event.target.getAttribute('data-swiper-slide-index')
          if(list[realIndex].fields.link.value.href !== '') {
            let a = document.createElement('a')
            a.setAttribute('target', list[realIndex]?.fields?.link?.value?.target)
            a.setAttribute('href', list[realIndex]?.fields?.link?.value?.href)
            document.body.appendChild(a)
            a.click()
          }
        }
      },
    })
  }

  const mouseOverBtn = () => {
    setOverButton(true)
  }

  const mouseLeaveBtn = () => {
    setOverButton(false)
  }

  const onSlideClick = (realIndex) => {
    gtag('event', 'Component_info', {
      'component_name': 'FreeRolling',
      'page_title': page?.name
    });
    setCurrentIndex(realIndex)
  }

  // 鼠标移动
  const mousemove = (e) => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight
    const eventX = e.clientX || (e.touches && e.touches[0]?.clientX) || 0
    const eventY = e.clientY || (e.touches && e.touches[0]?.clientY) || 0
    
    let domOffsetTop = rootEl.current?.getBoundingClientRect()?.top
    let top = 0
    if(eventY - 60 - domOffsetTop < 0) {
      top = 0
    } 
    else if(eventY - domOffsetTop > pageHeight - 60) {
      top = pageHeight - 120
    } 
    else {
      top = eventY - 60 - domOffsetTop
    }
    dragEl.current.style.top = top  + 'px'
    dragEl.current.style.left = eventX + 10 + 'px'
  }

  const swiperMouseDown  = (event) => {
    if(isMobile) {return false}
    let now = (new Date()).getTime()
    setMouseDownTime(now)
    var osmall = wrapperEl.current
    var e = event || window.event
    var offsetX = 0;
    /*用于保存小的div拖拽前的坐标*/
    if(swiperEl&&swiperEl.current){
      if(isAR){
        osmall.startX = e.clientX - osmall.offsetLeft - swiperRight +swiperEl.current.getBoundingClientRect().width
      }else{
        osmall.startX = e.clientX - osmall.offsetLeft
      }
    }
    document.onmousemove = function (event) {
      setIsMoving(true)
      var e = event || window.event
      offsetX = osmall.startX  - e.clientX
      var domOffsetX = count-offsetX
      if(isAR){
        if((Math.abs(domOffsetX) > swiperRight/2 ) || Math.abs(domOffsetX) === swiperRight/2){
          if(i!=1){ 
            osmall.style.transform =`translateX(${domOffsetX-swiperRight/2}px)`
            i=domOffsetX-swiperRight/2
          }else{
            osmall.style.transform = `translateX(${1}px)`
            i=1
          }
        } else if(domOffsetX < 0 || domOffsetX == 0){
          if(i!=swiperRight/2){
            osmall.style.transform =`translateX(${domOffsetX+swiperRight/2}px)`
            i=domOffsetX+swiperRight/2
          }else{
            osmall.style.transform = `translateX(${swiperRight/2}px)`
            i=swiperRight/2
          }
        }else{
          osmall.style.transform = `translateX(${domOffsetX}px)`
          i = (domOffsetX)
        }
      } else {
        if((Math.abs(domOffsetX) > swiperRight/2 ) || Math.abs(domOffsetX) === swiperRight/2){
          if(i!=1){ 
            osmall.style.transform =`translateX(${domOffsetX+swiperRight/2}px)`
            i=domOffsetX+swiperRight/2
          }else{
            osmall.style.transform = `translateX(${1}px)`
            i=1
          }
        }else if(domOffsetX > 0 || domOffsetX == 0){
          if(i!=-swiperRight/2){
            osmall.style.transform =`translateX(${domOffsetX-swiperRight/2}px)`
            i=domOffsetX-swiperRight/2
          }else{
            osmall.style.transform = `translateX(-${swiperRight/2}px)`
            i=-swiperRight/2
          }
        }else{
          osmall.style.transform = `translateX(${domOffsetX}px)`
          i = (domOffsetX)
        }
      }
      setCount(i);
    };
    document.onmouseup = function () {
      setTimeout(v=>{
        setIsMoving(false)
      },100)
      document.onmousemove = null;
      document.onmouseup = null;
    };
  }

  const swiperMouseUp = (e) => {
    if(isMoving){
      setTimeout(v=>{
        setIsMoving(false)
      },100)
    }

    let now = (new Date()).getTime()
    if(now - mouseDownTime > 200) { // 短按点击 超过300ms则判断为长按拖拽
      return false
    } else {
      setIsClick(true)      
    }
  }

  const onScroll = () => {
    if(rootEl.current.getBoundingClientRect().top < 300 && isMobile && swiper.current) {
      swiper.current.autoplay.start()
    }

    const winHeight = window.innerHeight || document.documentElement.clientHeight
    let freeImageDoms = document.querySelectorAll('.free-swiper-image')
    let freeTitleDoms = document.querySelectorAll('.free-swiper-title')
    let freeDescDoms = document.querySelectorAll('.free-swiper-desc')
    let freeBtnDoms = document.querySelectorAll('.btn-content')
    let iconDoms = document.querySelector('.swiper-button-content')
    for(let i=0; i<freeImageDoms.length; i++) {
      if(freeImageDoms[i].getBoundingClientRect().top < winHeight + 100) {
        freeImageDoms[i].setAttribute('class', 'free-swiper-image active')
      }
    }

    for(let i=0; i<freeDescDoms.length; i++) {
      if(freeDescDoms[i].getBoundingClientRect().top < winHeight + 300) {
        if(freeTitleDoms[i]) {
          freeTitleDoms[i].setAttribute('class', 'free-swiper-title active')
        }
        freeDescDoms[i].setAttribute('class', 'free-swiper-desc active')
        if(freeBtnDoms[i]) {
          freeBtnDoms[i].setAttribute('class', 'btn-content active')
        }
        let buildTimer = setTimeout((e) => {
          setMoving(true)
          clearTimeout(buildTimer)
        }, 2000)
      }
    }

    if(iconDoms.getBoundingClientRect().top < winHeight + 400) {
      iconDoms.setAttribute('class', 'swiper-button-content active')
    }
  }

  // 鼠标移出
  const mouseLeave = (e) => {
    setShowDrag(false)
  }

  // 鼠标移入
  const mouseOver = (e) => {
    setShowDrag(true)
  }

  const coclubTime = () => {
    let W = wrapperEl?.current?.getBoundingClientRect()?.width
    freetimer.current = setInterval(() => {
      if(!isAR){
        i=i-1;
        if( Math.abs(i) > W/2 || Math.abs(i) === W/2){
          i = 1
        }
      }else{
        i=i+1;
        if( i > W/2 || i === W/2){
          i = 1
        }
      }
      setCount(i);
    }, 20);
  }

  useEffect(() => {
    if(moving){
      coclubTime()
    }
    if(!moving && freetimer.current!=null){
      clearInterval(freetimer.current)
      freetimer.current = null
    }
  }, [moving]);

  useEffect(() => {
    if(list?.[currentIndex]?.fields?.link?.value?.href != '' && isClick) {
      let a = document.createElement('a')
      a.setAttribute('target', list[currentIndex]?.fields?.link?.value?.target)
      a.setAttribute('href', list[currentIndex]?.fields?.link?.value?.href)
      document.body.appendChild(a)
      a.click()
      let freetimer = setTimeout(e => {
        setIsClick(false)
        clearTimeout(freetimer)
      }, 1000)
    }
  }, [currentIndex]);

  useEffect(() => {
    setSwiperRight(wrapperEl?.current?.getBoundingClientRect()?.width)
    let buildTimer = setTimeout((e) => {
      if(isMobile) {
        buildSwiper()
      }
      clearTimeout(buildTimer)
    }, 100)
    window.addEventListener("scroll", onScroll)
    return () => {
      window.removeEventListener("scroll", onScroll)
    }
  }, [])

  const rootClasses = classNames("c-free-rolling", getOverallSettingsClasses(fields));
  return (
    <div className={rootClasses} datasourceid={rendering.dataSource} onMouseUp={swiperMouseUp} onMouseDown={swiperMouseDown} onMouseLeave={mouseLeave} onMouseOver={mouseOver}  onMouseMove={mousemove}>
      <div className="free-swiper-content" ref={rootEl}>
        <div className={["c-free_swiper swiper"].join(' ')} ref={swiperEl}>
          <div className="swiper-wrapper">
            {!isMobile && <div className="swiper-wrapper-con" ref={wrapperEl} style={{transform:[`translateX(${count}px)`]}}>
              {list && list.map((item, index) => (
                <div className="swiper-slide" key={index} onClick={()=>onSlideClick(index)}>
                  <div className={["free-swiper-image"].join(' ')} style={{ backgroundImage: `url(${item?.fields?.image?.value?.src})` }} id={`item__image${item.id}`}></div>
                  {!isMobile && item?.fields?.pc_title?.value && <RichText tag="div" className="free-swiper-title" field={item?.fields?.pc_title} id={`item__title${item.id}`} />}
                  {!isMobile && item?.fields?.pc_desc?.value && <RichText tag="div" className="free-swiper-desc" field={item?.fields?.pc_desc} id={`item__subtitle${item.id}`} />}
                  {list[index]?.fields?.buttonText?.value && <div className="btn-content" onMouseLeave={mouseLeaveBtn} onMouseOver={mouseOverBtn} id={`item__btn${item.id}`}>
                    <PrimaryButton {...{
                      buttonText: list[index]?.fields?.buttonText,
                      colorScheme: list[index]?.fields?.colorScheme,
                      iconName: list[index]?.fields?.iconName,
                      link: list[index]?.fields?.link
                    }} />
                  </div>}
                </div>
              ))}
              {list && list.map((item, index) => (
                <div className="swiper-slide" key={index} onClick={()=>onSlideClick(index)}>
                  <div className={["free-swiper-image"].join(' ')} style={{ backgroundImage: `url(${item?.fields?.image?.value?.src})` }} id={`item__image${item.id}`}></div>
                  {!isMobile && item?.fields?.pc_title?.value && <RichText tag="div" className="free-swiper-title" field={item?.fields?.pc_title} id={`item__title${item.id}`} />}
                  {!isMobile && item?.fields?.pc_desc?.value && <RichText tag="div" className="free-swiper-desc" field={item?.fields?.pc_desc} id={`item__subtitle${item.id}`} />}
                  {list[index]?.fields?.buttonText?.value && <div className="btn-content" onMouseLeave={mouseLeaveBtn} onMouseOver={mouseOverBtn} id={`item__btn${item.id}`}>
                    <PrimaryButton {...{
                      buttonText: list[index]?.fields?.buttonText,
                      colorScheme: list[index]?.fields?.colorScheme,
                      iconName: list[index]?.fields?.iconName,
                      link: list[index]?.fields?.link
                    }} />
                  </div>}
                </div>
              ))}
            </div>}
            {isMobile && list && list.map((item, index) => (
              <div className="swiper-slide" key={index}>
                <div className={["free-swiper-image"].join(' ')} style={{ backgroundImage: `url(${item?.fields?.image?.value?.src})` }} id={`item__image${item.id}`}></div>
                {isMobile && item?.fields?.m_title?.value && <RichText tag="div" className="free-swiper-title" field={item?.fields?.m_title} id={`item__title${item.id}`} />}
                {isMobile && item?.fields?.m_desc?.value && <RichText tag="div" className="free-swiper-desc" field={item?.fields?.m_desc} id={`item__subtitle${item.id}`} />}
                {list[index]?.fields?.buttonText?.value && <div className="btn-content" id={`item__btn${item.id}`}>
                  <PrimaryButton {...{
                    buttonText: list[index]?.fields?.buttonText,
                    colorScheme: list[index]?.fields?.colorScheme,
                    iconName: list[index]?.fields?.iconName,
                    link: list[index]?.fields?.link
                  }} />
                </div>}
              </div>
            ))}
          </div>
          <div className="swiper-button-content" id={`item__swiper_btn`}>
            <div className="swiper-button-next">
              <Icon name="ArrowBack" className="c-wtcr-content__left" />
            </div>
            <div className="swiper-button-prev">
              <Icon name="ArrowForward" className="c-wtcr-content__right" />
            </div>
          </div>
        </div>
        {/* drag */}
        <div ref={dragEl} className={["drag-content", (showDrag && !overButton) ? 'show' : 'hidden'].join(' ')}>
          <RichText tag="div" className="drag" field={dragtext} />
        </div>
      </div>
    </div>
  );
};

export default  FreeRolling;